export const RANKING_AUCTION_CREATE_PAGE_PATH = '/auction/ranking/create'
